import script from "./PaywallModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaywallModal.vue?vue&type=script&setup=true&lang=ts"

import "./PaywallModal.vue?vue&type=style&index=0&id=53a2488a&lang=scss"

const __exports__ = script;

export default __exports__